export default "__VITE_ASSET__bcdce704__"